import React from 'react';
import {Grid,Divider} from '@material-ui/core'
import {useSelector, useDispatch} from 'react-redux'
import {isEmpty} from 'lodash'
import CheckBoxInput from '../Inputs/CheckBoxInput'
import CheckBoxDatum from '../Inputs/CheckBoxDatum'
import CheckBoxInputAnsvarig from '../Inputs/CheckBoxInputAnsvarig'
import CheckBoxInputTaggning from '../Inputs/CheckBoxInputTaggning'

function KontakterSection(props) {

    const Flags = useSelector(state => state.accountsData.Flags) 
    const onChangeMstate=(Chips)=>{
        console.log(Chips)
    }
    return (<>
           <Grid container direction="row" alignItems="center" className='mt-2 pt-2 pl-2' style={{maxHeight:460,minHeight:120,overflowY:"auto"}}>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Kontaktperson ID"  MetaN={"Kontaktperson_ID"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Kontaktperson namn" MetaN={"Kontaktperson_namn"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Kontaktperson e-post" MetaN={"Kontaktperson_Epost"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Kontaktperson tele" MetaN={"Kontaktperson_tele"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Kontaktperson roll" MetaN={"Kontaktperson_roll"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Kontaktperson personnr" MetaN={"Kontaktperson_personnr"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Firmatecknare" MetaN={"Kontaktperson_Firmatecknare"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Nyhetsbrev" MetaN={"Kontaktperson_Nyhetsbrev"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAnsvarig Meta="Ägare" MetaN={"Kontaktperson_Ansvarig"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputTaggning Meta="Taggar" MetaN={"Kontaktperson_Taggar"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item className={"p-2"}  xs={12} >
            <Divider/>
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Skapad" MetaN={"Kontaktperson_Skapad"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
          
           </Grid>
        </>
    );
}

export default KontakterSection;